import { useState, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import clsx from 'clsx';
import { type ProgramList as ProgramListType, type SelectProgramConfig } from '../selectProgram.types';
import { ProgramList } from './ProgramList';
import { ProgramListWithSubSections } from './ProgramListWithSubSections';

type Props = {
    selectProgramConfig: SelectProgramConfig;
};

export function SelectProgram({ selectProgramConfig }: Props) {
    const { t } = useTranslation('back_royal');
    const [selectedProgramListIndex, setSelectedProgramListIndex] = useState<number>(0);

    const selectedProgramList = useMemo(
        () => selectProgramConfig[selectedProgramListIndex],
        [selectProgramConfig, selectedProgramListIndex],
    );

    const hasSubSections = 'subSections' in selectedProgramList && !!selectedProgramList.subSections.length;

    return (
        <div className="select-program px-4 py-5 sm:px-[80px]">
            <div className="list-select-buttons mb-6 flex justify-center gap-3 sm:gap-7">
                {selectProgramConfig.map((programList, index) => (
                    <button
                        type="button"
                        key={programList.title.key}
                        onClick={() => setSelectedProgramListIndex(index)}
                        className={clsx(
                            selectedProgramListIndex === index
                                ? 'selected bg-coral text-white'
                                : 'bg-transparent text-coral',
                            'list-select-button rounded border-none px-[14px] py-[12px] text-sm',
                        )}
                    >
                        {t(programList.title.key)}
                    </button>
                ))}
            </div>
            <div className="program-list-container">
                {hasSubSections ? (
                    <ProgramListWithSubSections programList={selectedProgramList} />
                ) : (
                    <ProgramList
                        items={(selectedProgramList as ProgramListType).items}
                        intro={selectedProgramList.intro}
                    />
                )}
            </div>
        </div>
    );
}
